var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenanceConnectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MaintenanceConnection_Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210.7 51",
    style: {
      enableBackground: "new 0 0 210.7 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.maintenance-connection-st0{fill:#F99D1C;}\r\n\t.maintenance-connection-st1{fill:#F58220;}\r\n\t.maintenance-connection-st2{fill:#EB6322;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st0",
    d: "M44.6,32.8c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c-0.1-0.9-0.4-1.8-0.9-2.7l-0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.3 L32.8,10.8c-0.2,0.6-0.5,1.2-0.8,1.8l-7.5,13.1l6.5,11.2c1.2,2.1,3.4,3.4,5.7,3.6h0.7c3.5,0,6.5-2.5,7.2-5.9c0,0,0,0,0,0 c0-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C44.6,33,44.6,32.9,44.6,32.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st1",
    d: "M16,11l6.4,11l6.4-11c1.9-3.3,1-7.4-2-9.6c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.3-0.2-0.4-0.3 C26,1,25.9,0.9,25.8,0.9c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.3-0.1-0.5-0.2 c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.1-0.5,0.1c-0.1,0-0.1,0-0.2,0 c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0-0.1,0-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.1C18.8,0.9,18.7,1,18.6,1 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0-0.1,0.1-0.2,0.1C15,3.6,14.1,7.7,16,11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M0,32.8c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c0.1-0.9,0.4-1.8,0.9-2.7l0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3 l10.5-18.2c0.2,0.6,0.5,1.2,0.8,1.8l7.5,13.1l-6.5,11.2c-1.2,2.1-3.4,3.4-5.7,3.6H7.4c-3.5,0-6.5-2.5-7.2-5.9c0,0,0,0,0,0 c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C0,33,0,32.9,0,32.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M54.3,4.1h4.4l4.2,10.5l4.2-10.5h4.3v15.1h-3.7v-9.1l-3.4,9.1h-3L58,10.1v9.1h-3.7V4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M83.6,16.5h-5.6L77,19.2h-3.9l5.5-15.1h4.3l5.5,15.1h-3.9L83.6,16.5z M80.7,8.1l-1.9,5.5h3.7L80.7,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M90,4.1h3.7v15.1H90V4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M109.9,4.1v15.1h-3.7l-6.2-9.3v9.3h-3.7V4.1h3.7l6.2,9.4V4.1H109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M111.8,4.1h11.7v3h-4v12.2h-3.7V7h-4V4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M134.6,7H129v3.1h4.9v2.8H129v3.3h5.6v3h-9.3V4.1h9.3V7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M150.6,4.1v15.1h-3.7l-6.2-9.3v9.3H137V4.1h3.7l6.2,9.4V4.1H150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M162.7,16.5H157l-0.9,2.7h-3.9l5.5-15.1h4.3l5.5,15.1h-3.9L162.7,16.5z M159.8,8.1l-1.9,5.5h3.7L159.8,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M182.7,4.1v15.1H179l-6.2-9.3v9.3h-3.7V4.1h3.7l6.2,9.4V4.1H182.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M192.3,3.9c3.6,0,6.3,2,7.2,5.3h-4.1c-0.6-1.3-1.8-1.9-3.2-1.9c-2.3,0-3.8,1.7-3.8,4.4c0,2.7,1.6,4.4,3.8,4.4 c1.4,0,2.5-0.6,3.2-1.9h4.1c-0.9,3.3-3.6,5.3-7.2,5.3c-4.5,0-7.6-3.2-7.6-7.7C184.7,7.1,187.9,3.9,192.3,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M211,7h-5.6v3.1h4.9v2.8h-4.9v3.3h5.6v3h-9.3V4.1h9.3V7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M61.3,22.6c3.6,0,6.3,2,7.2,5.3h-4.1c-0.6-1.3-1.8-1.9-3.2-1.9c-2.3,0-3.8,1.7-3.8,4.4c0,2.7,1.6,4.4,3.8,4.4 c1.4,0,2.5-0.6,3.2-1.9h4.1C67.6,36,64.9,38,61.3,38c-4.5,0-7.6-3.2-7.6-7.7C53.7,25.8,56.9,22.6,61.3,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M77.9,38.1c-4.3,0-7.8-3.2-7.8-7.8c0-4.5,3.5-7.7,7.8-7.7c4.3,0,7.7,3.2,7.7,7.7 C85.7,34.9,82.2,38.1,77.9,38.1z M77.9,34.7c2.4,0,4-1.7,4-4.4c0-2.7-1.6-4.4-4-4.4c-2.5,0-4,1.7-4,4.4 C73.9,33,75.5,34.7,77.9,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M101.3,22.8v15.1h-3.7l-6.2-9.3v9.3h-3.7V22.8h3.7l6.2,9.4v-9.4H101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M117.5,22.8v15.1h-3.7l-6.2-9.3v9.3h-3.7V22.8h3.7l6.2,9.4v-9.4H117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M129.4,25.8h-5.6v3.1h4.9v2.8h-4.9V35h5.6v3h-9.3V22.8h9.3V25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M138.8,22.6c3.6,0,6.3,2,7.2,5.3h-4.1c-0.6-1.3-1.8-1.9-3.2-1.9c-2.3,0-3.8,1.7-3.8,4.4 c0,2.7,1.6,4.4,3.8,4.4c1.4,0,2.5-0.6,3.2-1.9h4.1c-0.9,3.3-3.6,5.3-7.2,5.3c-4.5,0-7.6-3.2-7.6-7.7 C131.2,25.8,134.3,22.6,138.8,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M147.4,22.8h11.7v3h-4v12.2h-3.7V25.8h-4V22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M161,22.8h3.7v15.1H161V22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M174.5,38.1c-4.3,0-7.8-3.2-7.8-7.8c0-4.5,3.5-7.7,7.8-7.7c4.3,0,7.7,3.2,7.7,7.7 C182.3,34.9,178.8,38.1,174.5,38.1z M174.5,34.7c2.4,0,4-1.7,4-4.4c0-2.7-1.6-4.4-4-4.4c-2.5,0-4,1.7-4,4.4 C170.5,33,172.1,34.7,174.5,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maintenance-connection-st2",
    d: "M197.8,22.8v15.1h-3.7l-6.2-9.3v9.3h-3.7V22.8h3.7l6.2,9.4v-9.4H197.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceConnectionIcon);
export default __webpack_public_path__ + "static/media/MaintenanceConnectionIcon.e01ad041.svg";
export { ForwardRef as ReactComponent };